import { useState } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { motion } from "framer-motion";
import { NAV, COMPANY } from "@/data/site";
import { Logo } from "@/components/Logo";
import { EASE } from "@/components/Motion";

export const MobileMenu = () => {
  const [open, setOpen] = useState(false);
  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger
        className="grid h-11 w-11 place-items-center rounded-full bg-navy text-white transition-colors hover:bg-royal lg:hidden"
        aria-label="Open menu"
        data-testid="mobile-menu-open-button"
      >
        <Menu className="h-5 w-5" aria-hidden="true" />
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Content
          className="on-dark fixed inset-0 z-[60] flex flex-col overflow-y-auto bg-navy text-white data-[state=open]:animate-in data-[state=open]:fade-in-0"
          data-testid="mobile-menu"
          data-lenis-prevent
        >
          <Dialog.Title className="sr-only">Site navigation</Dialog.Title>
          <Dialog.Description className="sr-only">Links to every page of the PRPO LTD website</Dialog.Description>
          <div className="shell flex h-20 items-center justify-between">
            <Link to="/" onClick={() => setOpen(false)} aria-label="PRPO LTD — home">
              <Logo variant="white" />
            </Link>
            <Dialog.Close className="grid h-11 w-11 place-items-center rounded-full bg-lime text-navy" aria-label="Close menu" data-testid="mobile-menu-close-button">
              <X className="h-5 w-5" aria-hidden="true" />
            </Dialog.Close>
          </div>
          <nav aria-label="Mobile" className="shell flex-1 pt-8">
            <ul className="border-t border-white/15">
              {NAV.map((item, i) => (
                <motion.li
                  key={item.to}
                  initial={{ opacity: 0, y: 24 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, ease: EASE, delay: 0.05 + i * 0.06 }}
                  className="border-b border-white/15"
                >
                  <NavLink
                    to={item.to}
                    end={item.to === "/"}
                    onClick={() => setOpen(false)}
                    data-testid={`mobile-nav-link-${item.testid}`}
                    className={({ isActive }) => `flex items-baseline justify-between py-5 font-display text-4xl font-bold tracking-tight ${isActive ? "text-lime" : "text-white"}`}
                  >
                    {item.label}
                    <span className="font-mono text-xs text-white/60">0{i + 1}</span>
                  </NavLink>
                </motion.li>
              ))}
            </ul>
          </nav>
          <div className="shell space-y-2 py-10 text-sm text-white/75">
            <a href={`mailto:${COMPANY.email}`} className="block hover:text-lime">{COMPANY.email}</a>
            <a href={COMPANY.phoneHref} className="block hover:text-lime">{COMPANY.phone}</a>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
